//jquery('.product-info__description .custom-field__skin-type .custom-field--value').val().replace(/\//g, '-');





function watchForUpsell(){
  // console.log("start watching for offer popup...");
    setInterval(function(){ 
      // console.log('watching...');
      if ($('.bold-product.offer_id_515944').length) {
        $( 'body' ).addClass( 'offer_id_body_515944' );

        var bold_upsell_count = sessionStorage.getItem("bold_upsell_count");
        //  console.log("freebie count: "+bold_upsell_count);
         if(bold_upsell_count < 0){
            bold_upsell_count=0;
           sessionStorage.setItem("bold_upsell_count", bold_upsell_count);
        }
        if (bold_upsell_count > 2) {
          $('.offer_id_515944 .add-to-cart').css('opacity',.1).css('pointerEvents','none');
        }
      }  
    }, 1000); 
}

if($('.product-grid-item__content').length>0 || $('.cart-footer__main-buttons').length>0){
  watchForUpsell();
}


$('body').on('click','#add-to-cart-button, .navbar__icon--cart',function(){
     watchForUpsell();
  });


$('body').on('click','.quantity-input__button[data-freebie="1"]',function(){
  // console.log('minus');
  var bold_upsell_count = sessionStorage.getItem("bold_upsell_count");
  bold_upsell_count--;
  if(bold_upsell_count < 0){
    bold_upsell_count=0;
  }
  //  console.log("new freebie count: "+bold_upsell_count);
  sessionStorage.setItem("bold_upsell_count", bold_upsell_count);
  
  

});

// logic for preventing multiple cart additions on upsell BOLD offer offer_id_515944
var bold_upsell_count = sessionStorage.getItem("bold_upsell_count") || 0;
$('body').on('click','.offer_id_515944 .add-to-cart',function(){
  bold_upsell_count++;
  sessionStorage.setItem("bold_upsell_count", bold_upsell_count);
  //  console.log("freebie count: "+bold_upsell_count);
  if(bold_upsell_count>2){
    $('.offer_id_515944 .add-to-cart:not([added="true"]').css('opacity',.1).css('pointerEvents','none');
  }
});




 $('.product-slideshow').slick({
   //asNavFor: '.product-slideshow-controls'
 });

$('.product-slideshow-controls').slick({
  arrows: false,
  vertical: true,
  dots: true,
  slidesToShow: 8,
  slidesToScroll: 8,
  asNavFor: '.product-slideshow',
  infinite: false,
  centerMode: false,
  focusOnSelect: false,
  accessibility: false,
  draggable: false,
   autoplay: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
         slidesToScroll: 3,
      }
    }
  ]
});

// change big slide when clicking on thumbs
$('.product-slideshow-controls .product-slideshow-nav-item-container ').click(function(e){
    	var targetControls=$(this).closest('.product-slideshow-controls');
  
  		// update main photo
  		$('.product-slideshow').slick('slickGoTo',$(this).data('slick-index'));
        
  
  		// highlight thumb
 		 targetControls.find('.slick-slide').removeClass('slick-current');
  		targetControls.find('.slick-slide').removeClass('shown');
	     targetControls.find('.slick-slide').eq($(this).data('slick-index')).addClass('slick-current shown');
  
  

   		
   		
});
  
// // prevent dots from sliding the carousel if slide is in view
// $('.slick-dots li button').on('click', function(e){
//   	console.log($(this).html());
//   	clicked=$(this).html();
//   	var targetControls=$(this).closest('.product-slideshow-controls');
//   	console.log(targetControls);
  	
//   if(targetControls.find('.slick-slide').eq(clicked-1).hasClass('slick-active')){
    
      
//     console.log('in view, update classes');
//       // if in view, we stop normal propogation, but we still need to visually update
      
//       // remove identificatino off everything
//       $('.product-slideshow-controls .slick-slide').removeClass('slick-current');	
    
//       // add active state to the one we want to visually highlight
//       targetControls.find('.slick-slide').eq(clicked-1).addClass('slick-current');
//       // prevent slick from actually moving anything around
    
//     	// hilight current dot, and disable others
//         targetControls.find('.slick-dots li').removeClass('slick-active');
//     	$(this).parent().addClass('slick-active');
    
    
//     	// now... we need to actually slide in the appropriate image...
//     	$('.product-slideshow').slick('slickGoTo',clicked-1);
    
//     	// now prevent the sliding of the controls since the image is already in view
    
    
//    	 	 e.stopPropagation(); // use this
//   }else{
//   	console.log('not in view, fire normal');
//   }
// });





// hook up events on the MAIN photogallery to update the controls

if ($(window).width() > 991) {
  var slideAMountTrigger=8; 
}
else {
  var slideAMountTrigger=3;
}


$('.product-slideshow').on('afterChange', function(slick,currentSlide){

  currentSlide=currentSlide.currentSlide;
  var targetControls=$(this).closest('.product__slideshow').find('.product-slideshow-controls');;
  
  if($('.product-slideshow-controls .product-slideshow-nav-item-container').length>slideAMountTrigger){
    
    if(targetControls.find('.slick-slide').eq(currentSlide).hasClass('slick-active')){
      //if it is on screen, lets do our thing.....
      
      //update thumbs
      $('.product-slideshow-controls .slick-slide').removeClass('shown');
      $('.product-slideshow-controls .slick-slide').removeClass('slick-current');
      $('.product-slideshow-controls .slick-slide[data-slick-index="'+currentSlide+'"]').addClass('slick-current'); 

      // update dots
      // hilight current dot, and disable others
//       $('.product-slideshow-controls .slick-dots li').removeClass('slick-active');
//       $('.product-slideshow-controls .slick-dots').each(function(){
//         $(this).find('li').eq(currentSlide).addClass('slick-active');
//       });
    }else{
    	// old fashioned way if it is off screen
      targetControls.slick('slickGoTo',currentSlide);
    }
    
  }else{
    $('.product-slideshow-controls .slick-slide').removeClass('shown');
    $('.product-slideshow-controls .slick-slide').addClass('shown');
  }	  

});



// if ($(window).width() > 991) {
//   var slideAMountTrigger=8; 
// }
// else {
//   var slideAMountTrigger=3;
// }


// $('.product-slideshow').on('afterChange', function(slick,currentSlide){

//   currentSlide=currentSlide.currentSlide;

//   if($('.product-slideshow-controls .product-slideshow-nav-item-container').length>slideAMountTrigger){
    
//     $('.product-slideshow-controls').slick('slickGoTo',currentSlide);
//     $('.product-slideshow-controls .product-slideshow-nav-item-container').removeClass('shown');
//     $('.product-slideshow-controls .product-slideshow-nav-item-container').removeClass('active ');
//     $('.product-slideshow-controls .product-slideshow-nav-item-container[data-slick-index="'+currentSlide+'"]').addClass('active');  
    
//   }else{
//     $('.product-slideshow-controls .product-slideshow-nav-item-container').removeClass('shown');
//     $('.product-slideshow-controls .product-slideshow-nav-item-container[data-slick-index="'+currentSlide+'"]').addClass('shown');
//   }	  

// });


	
$(window).resize(function(){
  if($('.product-slideshow').length>0){
  $('.product-slideshow')[0].slick.refresh();
  }
  });




$( ".mobile-nav__sec-heading" ).click(function() {
	$(".mobile-nav__accordion-trigger").attr("aria-expanded","false");
  $(".mobile-nav").attr("aria-expanded","false");
  $("#shop-all-1-content").attr("aria-expanded","false");
  $("#face-2-content").attr("aria-expanded","false");
  $("#body-3-content").attr("aria-expanded","false");
});

$( "#shop-all-1-trigger" ).click(function() {
  $("#shop-all-1-content").attr("aria-expanded","true");
});

$( "#face-2-trigger" ).click(function() {
  $("#face-2-content").attr("aria-expanded","true");
});

$( "#body-3-trigger" ).click(function() {
  $("#body-3-content").attr("aria-expanded","true");
});

  
$('.product__form').stickySidebar({
  containerSelector: '.product',
  innerWrapperSelector: '.product__sticky',
  topSpacing: 25,
  bottomSpacing: 25,
  minWidth: 991
});

$("video").oncanplay = function() {
    $("video").prop('muted', true);
};

$(".audio-control").click(function () {
    if ($("video").prop('muted')) {
        $("video").prop('muted', false);
        $(this).addClass('unmute-video'); // changing icon for button

    } else {
        $("video").prop('muted', true);
        $(this).removeClass('unmute-video'); // changing icon for button
    }
    console.log($("video").prop('muted'))
});

$(".mute-control").click(function () {
    if ($("video").prop('muted')) {
        $("video").prop('muted', false);
        $(this).addClass('unmute-video'); // changing icon for button

    } else {
        $("video").prop('muted', true);
        $(this).removeClass('unmute-video'); // changing icon for button
    }
    console.log($("video").prop('muted'))
});


$(window).on('load', function(){
 
  
  
  
  
//  if($('.product-slideshow-controls .product-slideshow-nav-item-container').length>slideAMountTrigger){
  
//   $('.product-slideshow-controls').slick({
//   		'vertical':true,
// 		'verticalSwiping':true,
//     'arrows':false,
// 		//infinite: true,
//      //asNavFor: '.product-slideshow',
// 		 slidesToShow: slideAMountTrigger,
//     	dots:true,
    
 
// 	});
  
//  }else if($('.product-slideshow-controls').length>0){
   
//    $('.product-slideshow-controls .product-slideshow-nav-item-container').eq(0).addClass('shown');
//  }
  	
   
//   $('.product-slideshow-controls .product-slideshow-nav-item-container ').click(function(e){
//     	e.preventDefault();
//     	e.stopPropagation();
//    	 	$('.product-slideshow').slick('slickGoTo',$(this).data('slick-index'));
//         console.log('link fired!');
   		
//    		if($('.product-slideshow-controls .product-slideshow-nav-item-container').length>slideAMountTrigger){
//     		$('.product-slideshow-controls').slick('slickGoTo',$(this).data('slick-index'));
//         }
    
//  		$('.product-slideshow-controls .product-slideshow-nav-item-container').removeClass('shown');
//  		$(this).addClass('shown');
    
//     	return false;
		
// 	});
  
 
  

	
  
  
 
  
});




 


// Sticky Header

$(document).ready(function(){ 
	$(window).on('resize', function(){ 
		if ($(window).width() < 991) { 
		
		}
		else { 
			$('.product-header').removeClass('product-header--active');
		}
	}).resize();
	
	$(window).scroll(function() {
		if ($(window).width() < 991) { 
			if ($(window).scrollTop() > 850) {
				$('.product-header').addClass('product-header--active');
			} 
			else {
				$('.product-header').removeClass('product-header--active');	
			}
		}
	});
	
});
  
  
  



$('.product-nav-mobile .product-nav li').on('click',function(){
  
  $('.product-nav-mobile .product-nav li').each(function(){
   $('.product-nav-mobile .product-nav li').removeClass('active');
  });

	$(this).addClass('active');
});

$('.product-nav-mobile .product-nav li').on('click',function(){
  //max left scroll
var maxScrollLeft=$(".product-nav-mobile .product-nav").scrollLeft('.product-nav-mobile .product-nav').prop('scrollWidth') - $(".product-nav-mobile .product-nav").width();
    var left = $(this).offset().left
  var width = $(".product-nav-mobile .product-nav").width();
  var diff = left - width/2
  $(".product-nav-mobile .product-nav").scrollLeft($(".product-nav-mobile .product-nav").scrollLeft()+diff)

  
});





function removeReviews(){
  $('#pagination-product__product-wrapper .product-grid-item__text .okeReviews-reviewsSummary-ratingCount > span').text(function () {
    return $(this).text().replace('Reviews', '').replace('Review', '');
  });
}




$(document).ready(function(){ 
  removeReviews();
  setInterval(function(){
    removeReviews();
  }, 800);
  
  
  
  $(window).resize(function() {
    $(".promo-circle").css("height", $(".promo-circle").outerWidth() + "px");

    if ($(window).width() < 991) { 

    }
    else { 
      $('.product-grid-item__text .okeReviews-reviewsSummary-ratingCount > span').text(function () {
        return $(this).text().replace('Reviews', '');
      });
      $('.product-grid-item__text .okeReviews-reviewsSummary-ratingCount > span').text(function () {
        return $(this).text().replace('Review', '');
      });
      
      
      
     /* var div = $(".product__form").height();
	  var win = $(window).height();
      
      function setPosition() {
        if (div > win ) {
          $(".product__form").css({
            'position': 'sticky',
            'top': window.innerHeight - $(".product__form").innerHeight()
          });
        }
        else {
          $(".product__form").css({
            'position': 'sticky',
            'top': '0'
          });
        }
      }*/
      //setPosition();
      //$(window).resize(setPosition());
    }

      
      
    


  }).resize();
});
